<template>
  <v-container>
    <h1>All Logos</h1>
    <v-row v-if="logos.length > 0">
      <v-col
        class="logos"
        v-for="(logo, index) in logos"
        :key="index"
        sm="4"
        cols="12"
      >
        <v-img aspect-ratio="1" :src="logo.photo" width="100%"></v-img>
        <v-btn @click="handleDelete(logo, index)" class="positioning" icon
          ><v-icon color="error">mdi-delete</v-icon></v-btn
        >
      </v-col>
    </v-row>
    <h3 v-else-if="loading">Loading ...</h3>
    <h3 v-else>No Logos Found !</h3>
  </v-container>
</template>

<script>
import { IndexData, DeleteData } from "@/helpers/apiMethods";

export default {
  data() {
    return {
      logos: [],
      loading: false
    };
  },
  methods: {
    showData(id) {
      this.loading = true;
      IndexData({
        reqName: `content/csrs/${this.$route.params.id}/csr-logos`,
        id: id
      })
        .then(res => {
          const { data } = res.data;
          this.logos = data;
          this.loading = false;
        })
        .catch(() => {});
    },
    handleDelete(logo, index) {
      this.popUp().then(value => {
        if (!value.dismiss) {
          DeleteData({
            reqName: `content/csrs/${this.$route.params.id}/csr-logos`,
            id: logo.id
          })
            .then(() => {
              this.logos.splice(index, 1);
            })
            .catch(() => {});
        }
      });
    }
  },
  watch: {
    $route: {
      handler(route) {
        if (route.name === "CsrLogos") {
          this.$nextTick(() => {
            this.showData(route.params.id);
          });
        }
      },
      immediate: true,
      deep: true
    }
  }
};
</script>
